<div #tableWrapper class="app-datatable">
  <!-- Header -->
  <!-- Search Bar -->
  <div class="row search-bar-data-table" *ngFor="let searchBar of config.searchBar; index as i">
    <app-search-bar
      *ngIf="!searchBar?.hidden"
      [alias]="config.id + '_' + i"
      [syncWithQueryParams]="config.syncWithQueryParams"
      [searching]="config?.loadingIndicator"
      [options]="searchBar?.availableSearchFields"
      [defaultOption]="searchBar?.defaultOption"
      [disabled]="searchBar?.disabled"
      [filterHidden]="searchBar?.filterHidden"
      [iconHidden]="searchBar?.iconHidden"
      (searchEvent)="onSearch($event)"
    >
    </app-search-bar>
  </div>
  <!-- Custom Header -->
  <ng-container *ngTemplateOutlet="customHeader; context: { $implicit: this }"> </ng-container>

  <!-- Tool Bar -->
  <div class="toolbar" *ngIf="!config.toolBar.hidden">
    <!-- Show Selected (checkbox) -->
    <div
      class="show-selected"
      *ngIf="
        {
          rows: config.rows,
          selectedRows: config.selection.selectedRows,
          allRowsSelected: allRowsSelected
        } | applyFunctionOrReturn: getSelectedRowsCount
      "
      [ngPlural]="
        ({
          rows: config.rows,
          selectedRows: config.selection.selectedRows,
          allRowsSelected: allRowsSelected
        } | applyFunctionOrReturn: getSelectedRowsCount) > 1
      "
    >
      <ng-template ngPluralCase="=1">
        <mat-hint class="max-hint-selected-checkbox">
          You have selected
          <span>{{
            {
              rows: config.rows,
              selectedRows: config.selection.selectedRows,
              allRowsSelected: allRowsSelected
            } | applyFunctionOrReturn: getSelectedRowsCount
          }}</span>
          item</mat-hint
        >
      </ng-template>
      <ng-template ngPluralCase="other">
        <mat-hint class="max-hint-selected-checkbox">
          You have selected
          <span>{{
            {
              rows: config.rows,
              selectedRows: config.selection.selectedRows,
              allRowsSelected: allRowsSelected
            } | applyFunctionOrReturn: getSelectedRowsCount
          }}</span>
          items</mat-hint
        >
      </ng-template>
    </div>

    <div class="push-right">
      <!-- Csv Downloader Button -->
      <div *ngIf="!config.toolBar.exportCsv?.hidden">
        <app-export-file
          class="wrapper-export"
          [disabled]="config.toolBar.exportCsv?.disabled"
          [output]="config.toolBar.exportCsv?.output"
          [filename]="config.toolBar.exportCsv?.filename"
          [totalDocs]="config.pagination?.totalItems"
          [type]="'CSV'"
          [useNewMethod]="true"
          [exportToBrowser$]="
            { rows: config.rows, columns: config.columns } | exportData: 'browser':config:getSearchBarValues
          "
          [exportToEmail$]="
            { rows: config.rows, columns: config.columns } | exportData: 'email':config:getSearchBarValues
          "
        >
        </app-export-file>
      </div>
      <!-- Select All Button -->
      <mat-checkbox
        *ngIf="!(config.selection.hidden || config.toolBar.selectAllRows?.hidden)"
        [style.display]="'flex'"
        [style.align-items]="'center'"
        [checked]="allRowsSelected"
        [disabled]="!config.rows?.length"
        (change)="onSelectAllRows()"
      >
        Select All
      </mat-checkbox>
      <!-- Refresh Table Button -->
      <button *ngIf="!config.toolBar?.refreshTable?.hidden" mat-icon-button (click)="onRefresh(true)">
        <mat-icon>refresh</mat-icon>
      </button>
      <!-- Toogle Columns Button -->
      <button *ngIf="!config.toolBar?.toggleColumns?.hidden" mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>view_column</mat-icon>
      </button>
      <!-- Add Item Table Button -->
      <button
        *ngIf="!config.toolBar?.addItem?.hidden"
        mat-icon-button
        (click)="config.toolBar?.addItem?.function(this)"
      >
        <mat-icon>add</mat-icon>
      </button>
      <!-- Bulk Edit Table Button -->
      <div
        *ngIf="!config.toolBar?.bulkEdit?.hidden"
        [matTooltip]="
          { selectedRows: this.config.selection.selectedRows, allRowsSelected: allRowsSelected }
            | applyFunctionOrReturn: getBulkActionMessageWhenItsDisabled
        "
      >
        <button
          mat-icon-button
          [disabled]="
            !(
              { selectedRows: this.config.selection.selectedRows, allRowsSelected: allRowsSelected }
              | applyFunctionOrReturn: canBulkAction
            )
          "
          matBadge="!"
          matBadgeColor="warn"
          matBadgeSize="small"
          [matBadgeHidden]="
            !(
              { selectedRows: this.config.selection.selectedRows, allRowsSelected: allRowsSelected }
              | applyFunctionOrReturn: isThereMoreSelectedRowsThanTheLimit
            )
          "
          (click)="config.toolBar?.bulkEdit?.function(this)"
        >
          <mat-icon>edit_note</mat-icon>
        </button>
      </div>
      <!-- Bulk Unlink Table Button -->
      <div
        *ngIf="!config.toolBar?.bulkUnlink?.hidden"
        [matTooltip]="
          { selectedRows: this.config.selection.selectedRows, allRowsSelected: allRowsSelected }
            | applyFunctionOrReturn: getBulkActionMessageWhenItsDisabled
        "
      >
        <button
          mat-icon-button
          [disabled]="
            !(
              { selectedRows: this.config.selection.selectedRows, allRowsSelected: allRowsSelected }
              | applyFunctionOrReturn: canBulkAction
            )
          "
          matBadge="!"
          matBadgeColor="warn"
          matBadgeSize="small"
          [matBadgeHidden]="
            !(
              { selectedRows: this.config.selection.selectedRows, allRowsSelected: allRowsSelected }
              | applyFunctionOrReturn: isThereMoreSelectedRowsThanTheLimit
            )
          "
          (click)="config.toolBar?.bulkUnlink?.function(this)"
        >
          <mat-icon>link_off</mat-icon>
        </button>
      </div>
      <ng-container *ngTemplateOutlet="customToolBar; context: { $implicit: this }"> </ng-container>
    </div>

    <mat-menu #menu="matMenu">
      <mat-selection-list (selectionChange)="onSetColumns($event)">
        <mat-list-option
          *ngFor="let column of _allColumns"
          [selected]="true"
          [value]="column"
          [disableRipple]="false"
          (click)="$event.stopPropagation()"
        >
          {{ column.name }}
        </mat-list-option>
      </mat-selection-list>
    </mat-menu>
  </div>
  <!-- Table -->
  <ngx-datatable
    [id]="'table-' + config.id"
    [class]="config.cssClass"
    [rowIdentity]="getRowId"
    [rows]="config.rows"
    [columns]="config.columns"
    [columnMode]="config.columnMode"
    [loadingIndicator]="config.loadingIndicator"
    [externalPaging]="config.externalPaging"
    [externalSorting]="config.externalSorting"
    [count]="config.pagination?.totalItems"
    [offset]="config.pagination?.currentPage"
    [limit]="config.pagination?.itemsPerPage"
    [reorderable]="config.reorderable"
    [headerHeight]="config.headerHeight"
    [rowHeight]="config?.rowHeight"
    [footerHeight]="config.footerHeight"
    [scrollbarH]="config?.scrollbarH"
    [scrollbarV]="config?.scrollbarV"
    [sortType]="config.sortType"
    [selected]="config.selection?.selectedRows"
    [selectionType]="'checkbox'"
    [style.box-shadow]="!config?.boxShadow && 'none'"
    [summaryHeight]="config.summary?.height"
    [summaryPosition]="config.summary?.position"
    [summaryRow]="!config.summary?.hidden"
    (sort)="onSort()"
    (activate)="onActivate($event, config.columns)"
  >
    <!-- Selection column -->
    <ngx-datatable-column
      *ngIf="!config.selection.hidden"
      [width]="60"
      [sortable]="false"
      [draggable]="false"
      [resizeable]="false"
      [frozenLeft]="true"
    >
      <!-- Header -->
      <ng-template ngx-datatable-header-template>
        <mat-checkbox
          [matTooltip]="allRowsSelected | applyFunctionOrReturn: getCheckboxMessageWhenItsDisabled"
          [checked]="
            { rows: config.rows, selectedRows: config.selection.selectedRows, page: config.page }
              | applyFunctionOrReturn: isPageSelected
          "
          [indeterminate]="
            { rows: config.rows, selectedRows: config.selection.selectedRows, page: config.page }
              | applyFunctionOrReturn: isIndeterminate
          "
          [disabled]="
            ({
              rows: config.rows,
              selectedRows: config.selection.selectedRows,
              disableRows: config.disableRows,
              allRowsSelected: allRowsSelected
            } | applyFunctionOrReturn: getEnabledRowsCount) === 0 || allRowsSelected
          "
          (change)="onSelectAllPage()"
        >
        </mat-checkbox>
      </ng-template>

      <!-- Cell -->
      <ng-template
        ngx-datatable-cell-template
        let-row="row"
        let-isSelected="isSelected"
        let-onCheckboxChangeFn="onCheckboxChangeFn"
      >
        <mat-checkbox
          [matTooltip]="allRowsSelected | applyFunctionOrReturn: getCheckboxMessageWhenItsDisabled"
          [disabled]="!({ rows: config.disableRows, allSelected: allRowsSelected } | columnFunction: isRowEnabled:row)"
          [checked]="config.selection.selectedRows | columnFunction: isRowSelected:row"
          (change)="onSelectRow(row)"
        >
        </mat-checkbox>
      </ng-template>
    </ngx-datatable-column>
    <!-- Columns -->
    <ngx-datatable-column
      *ngFor="let col of config.columns"
      [prop]="col.prop"
      [name]="col.name"
      [sortable]="!col.button && col.sortable"
      [draggable]="col.draggable"
      [resizeable]="col.resizeable"
      [cellTemplate]="col.cellTemplate"
      [width]="col.width"
      [summaryFunc]="col.summaryFunc"
      [frozenLeft]="col.frozenLeft"
      [fronzeRight]="col.frozenRight"
    >
      <!-- Header -->
      <ng-template ngx-datatable-header-template let-column="column">
        <span>{{ column.name }}</span>
        <ng-container *ngIf="col?.headerTooltip">
          <span [matTooltip]="col.headerTooltip.message">
            <mat-icon>{{ col.headerTooltip.icon }}</mat-icon>
          </span>
        </ng-container>
      </ng-template>

      <ng-template ngx-datatable-cell-template let-value="value" let-row="row">
        <!-- Normal cell (template) -->
        <ng-template #normal
          ><span
            [matTooltip]="
              ({ rows: config.rows, columns: config.columns }
                | columnFunction: col.toolTip:row:col:(value | cellRender: value:row:col | pipes: col?.pipes)) ||
              ({ rows: config.rows, columns: config.columns } | cellRender: value:row:col | pipes: col?.pipes)
            "
            >{{ { rows: config.rows, columns: config.columns } | cellRender: value:row:col | pipes: col?.pipes }}</span
          >
        </ng-template>
        <!-- Link cell (template) -->
        <ng-template #link>
          <span>
            <a
              *ngIf="!col?.link?.useHref"
              target="{{ col?.link?.target ? col.link.target : '_self' }}"
              [routerLink]="col?.link | linkBuilder: row"
              [queryParams]="row | applyFunctionOrReturn: col.link.queryParams"
              [matTooltip]="
                ({ rows: config.rows, columns: config.columns }
                  | columnFunction: col.toolTip:row:col:(value | cellRender: value:row:col | pipes: col?.pipes)) ||
                ({ rows: config.rows, columns: config.columns } | cellRender: value:row:col | pipes: col?.pipes)
              "
            >
              {{ { rows: config.rows, columns: config.columns } | cellRender: value:row:col | pipes: col?.pipes }}
            </a>
            <a
              *ngIf="col?.link?.useHref"
              target="{{ col?.link?.target ? col.link.target : '_self' }}"
              [href]="col?.link | linkBuilder: row"
            >
              {{ { rows: config.rows, columns: config.columns } | cellRender: value:row:col | pipes: col?.pipes }}</a
            >
          </span>
        </ng-template>
        <!-- Button cell (template) -->
        <ng-template #button>
          <span class="button-column" *ngIf="col.button">
            <div
              *ngIf="row | applyFunctionOrReturn: col.button.disabled; then buttonDisabled; else buttonEnabled"
            ></div>
            <ng-template #buttonEnabled>
              <button
                mat-icon-button
                color="primary"
                [matTooltip]="col.button?.tooltip"
                [class]="col.button?.class"
                (click)="col.button.onClick(row)"
              >
                <mat-icon>{{ col.button.icon }}</mat-icon>
              </button>
            </ng-template>
            <ng-template #buttonDisabled>
              <button disabled mat-icon-button color="black">
                <mat-icon>{{ col.button.icon }}</mat-icon>
              </button>
            </ng-template>
          </span>
        </ng-template>
        <!-- Icon cell (template) -->
        <ng-template #icon>
          <span class="icon-column" *ngIf="col.icon && !col.inlineEdit?.control && !col?.link?.path && !col.button">
            <div *ngIf="!(row | applyFunctionOrReturn: col.icon?.hidden)">
              <span
                [matTooltip]="{ rows: config.rows, columns: config.columns } | columnFunction: col.icon?.tooltip:row"
              >
                <mat-icon
                  *ngIf="col.icon?.name"
                  [style.color]="{ rows: config.rows, columns: config.columns } | columnFunction: col.icon?.color:row"
                  >{{ { rows: config.rows, columns: config.columns } | columnFunction: col.icon?.name:row }}</mat-icon
                >
                <span
                  *ngIf="col.icon?.class"
                  [ngClass]="{ rows: config.rows, columns: config.columns } | columnFunction: col.icon?.class:row"
                ></span>
              </span>
            </div>
          </span>
        </ng-template>

        <!-- Not editing (template) -->
        <ng-template #notEditingCell>
          <div
            *ngIf="
              (!col.link?.path || (row | applyFunctionOrReturn: col.link?.disabled)) && !col.button && !col.icon;
              then normal
            "
          ></div>
          <div
            *ngIf="
              col.link?.path && !(row | applyFunctionOrReturn: col.link?.disabled) && !col.button && !col.icon;
              then link
            "
          ></div>
          <div
            *ngIf="
              (!col.link?.path || (row | applyFunctionOrReturn: col.link?.disabled)) && col.button && !col.icon;
              then button
            "
          ></div>
          <div
            *ngIf="
              (!col.link?.path || (row | applyFunctionOrReturn: col.link?.disabled)) && !col.button && col.icon;
              then icon
            "
          ></div>
        </ng-template>

        <!-- Editing (template) -->
        <ng-template #editingCell>
          <div
            [class]="
              ({ disabledRows: config.disableRows, editing: editing } | columnFunction: canEdit:row:col)
                ? 'inline-edit-wrapper'
                : ''
            "
          >
            <div class="inline-edit-toggle ellipsis" *ngIf="!editing[row.id + '-' + col.prop]">
              <ng-container *ngTemplateOutlet="notEditingCell"> </ng-container>
            </div>
            <ng-template [ngIf]="editing[row.id + '-' + col.prop]" [ngSwitch]="col.inlineEdit?.control">
              <div [formGroup]="inlineFormGroup">
                <div class="cell-wrapper-content-editing" id="scroll{{ col.prop }}">
                  <mat-form-field [value]="value" appearance="standard">
                    <ng-container *ngSwitchCase="'input'">
                      <input
                        type="text"
                        matInput
                        [formControlName]="row.id + '-' + col.prop"
                        (keydown.enter)="updateInlineEdit(row, col)"
                        (keydown.esc)="cancelInlineEdit(row, col)"
                      />
                    </ng-container>
                    <ng-container *ngSwitchCase="'date'">
                      <input
                        matInput
                        [formControlName]="row.id + '-' + col.prop"
                        [min]="col.inlineEdit?.date?.min | columnFunction: col.inlineEdit?.date?.min:row"
                        [max]="col.inlineEdit?.date?.max | columnFunction: col.inlineEdit?.date?.max:row"
                        [matDatepicker]="datePicker"
                        (keydown.enter)="updateInlineEdit(row, col)"
                        (keydown.esc)="cancelInlineEdit(row, col)"
                        (click)="datePicker.open()"
                      />
                      <mat-datepicker color="primary" #datePicker></mat-datepicker>
                    </ng-container>
                    <ng-container *ngSwitchCase="'select'">
                      <mat-select
                        [formControlName]="row.id + '-' + col.prop"
                        (keydown.enter)="updateInlineEdit(row, col)"
                        (keydown.esc)="cancelInlineEdit(row, col)"
                      >
                        <mat-option
                          *ngFor="let option of col.inlineEdit.select.options"
                          [value]="option"
                          [disabled]="option.disabled"
                          >{{ option.label }}
                        </mat-option>
                      </mat-select>
                    </ng-container>
                    <ng-container *ngSwitchCase="'search'">
                      <input
                        type="text"
                        matInput
                        [formControlName]="row.id + '-' + col.prop"
                        [matAutocomplete]="auto"
                        (keydown.enter)="updateInlineEdit(row, col)"
                        (keydown.esc)="cancelInlineEdit(row, col)"
                      />
                      <mat-autocomplete #auto="matAutocomplete" [displayWith]="searchInputLabel">
                        <mat-option *ngIf="col.inlineEdit?.search?.showNullOption" [value]="null">None</mat-option>
                        <mat-option
                          (click)="$event.stopPropagation()"
                          *ngFor="let option of inlineSearchFilteredOptions | async"
                          [value]="option"
                        >
                          {{ option[col.inlineEdit.search.propToDisplay] }}
                        </mat-option>
                      </mat-autocomplete>
                    </ng-container>
                    <button
                      mat-button
                      matSuffix
                      mat-icon-button
                      [disabled]="inlineFormGroup.pristine || inlineFormGroup.invalid"
                      (click)="updateInlineEdit(row, col)"
                    >
                      <mat-icon>check</mat-icon>
                    </button>
                    <button mat-button matSuffix mat-icon-button (click)="cancelInlineEdit(row, col)">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>
                </div>
              </div>
            </ng-template>
          </div>
        </ng-template>

        <!-- Cell/template picker -->
        <div
          *ngIf="
            !col.inlineEdit?.control ||
              (col.inlineEdit?.disabled | columnFunction: col.inlineEdit?.disabled:row:col:value:config);
            then notEditingCell;
            else editingCell
          "
        ></div>
      </ng-template>
    </ngx-datatable-column>
    <!-- Action column -->
    <ngx-datatable-column
      *ngIf="config.actionColumn"
      name="Actions"
      [sortable]="false"
      [draggable]="false"
      [frozenRight]="true"
    >
      <ng-template #options let-row="row" let-value="value" ngx-datatable-cell-template>
        <button
          class="action-more-horiz"
          mat-icon-button
          [matMenuTriggerFor]="actionsMenu"
          aria-label="More"
          color="primary"
        >
          <mat-icon>more_horiz</mat-icon>
        </button>
        <mat-menu class="custom-menu-management" #actionsMenu="matMenu">
          <div *ngFor="let action of config.actionColumn">
            <button
              *ngIf="!(row | applyFunctionOrReturn: action.hidden)"
              mat-menu-item
              (click)="action.function(row, this)"
            >
              <mat-icon>{{ action.icon }}</mat-icon>
              <span>{{ action.text }}</span>
            </button>
          </div>
        </mat-menu>
      </ng-template>
    </ngx-datatable-column>
    <!-- Footer -->
    <ngx-datatable-footer>
      <ng-template ngx-datatable-footer-template>
        <app-paginator
          *ngIf="!config.paginator?.hidden"
          [alias]="config.id"
          [syncWithQueryParams]="config.syncWithQueryParams"
          [length]="config.pagination?.totalItems"
          [disabled]="config.paginator?.disabled"
          [pageSizeOptions]="config.paginator?.pageSizeOptions"
          [labelHidden]="config.paginator?.labelHidden"
          (changeEvent)="onPaginate($event)"
        >
        </app-paginator>
      </ng-template>
    </ngx-datatable-footer>
  </ngx-datatable>
</div>
